export const FOLHA_PONTO_FIND_ONE = 'FOLHA_PONTO_FIND_ONE';
export const FOLHA_PONTO_FIND_ONE_SUCCESS = 'FOLHA_PONTO_FIND_ONE_SUCCESS';

export const FOLHA_PONTO_SAVE = 'FOLHA_PONTO_SAVE';
export const FOLHA_PONTO_SAVE_SUCCESS = 'FOLHA_PONTO_SAVE_SUCCESS';

export const FOLHA_PONTO_UPDATE = 'FOLHA_PONTO_UPDATE';
export const FOLHA_PONTO_UPDATE_SUCCESS = 'FOLHA_PONTO_UPDATE_SUCCESS';

export const FOLHA_PONTO_CLEAN = 'FOLHA_PONTO_CLEAN';
export const FOLHA_PONTO_CLEAR_SELECTED = 'FOLHA_PONTO_CLEAR_SELECTED';

export const FOLHA_PONTO_UPDATE_STATUS = 'FOLHA_PONTO_UPDATE_STATUS';
export const FOLHA_PONTO_UPDATE_STATUS_SUCCESS = 'FOLHA_PONTO_UPDATE_STATUS_SUCCESS';

export const FOLHA_PONTO_DELETE = 'FOLHA_PONTOA_DELETE';
export const FOLHA_PONTO_DELETE_SUCCESS = 'FOLHA_PONTO_DELETE_SUCCESS';

export const FOLHA_PONTO_DOWNLOAD = 'FOLHA_PONTO_DOWNLOAD';
export const FOLHA_PONTO_UPLOAD_FILLED = 'FOLHA_PONTO_UPLOAD_FILLED';
export const FOLHA_PONTO_REPORT = 'FOLHA_PONTO_REPORT';